
const routerOthers = [
  {
    path: '/404',
    component: () => import('@/views/global/404.vue'),
    name: 'NotFound',
    meta: {
      title: '404',
      layout: 'BlankLayout'
    },
    hidden: true
  },
  {
    path: '/globalSearch',
    component: () => import('@/views/global/GlobalSearch.vue'),
    meta: { title: '全局搜索' },
    hidden: true
  }
]

export default routerOthers;
